import React from 'react'
import "./kdmprivacypolicy.scss"
import { Image_Url } from '../../constants/imageUrl/ImageUrl'

const KdmPrivacypolicy = () => {
    return (
        <div className="KdmPrivacyConatiner">

            <main>
            <section>
                    <img alt="kdmfooter" src={Image_Url.KDMHEADER} className='kdm_header_footer'/>
                </section>
                <h1 className='header_text'>NOTICE OF PRIVACY</h1>
                <section>
                    <p>
                        In terms of the provisions of the Federal Law on Protection of Personal Data Held by Private
                        Parties (hereinafter referred to as "the Law"), the company GRUPO MOTOMEX, S.A. OF
                        C.V. with address located at Avenida Pino Suarez Number 700-7, Zona Centro C.P. 64000 in
                        Monterrey, Nuevo León, and subsidiaries. With electronic address www.motomex.com,
                        establishes this Privacy Notice in accordance with the following:
                    </p>
                </section>
                <section>
                    <p>Terms and Conditions</p>
                    <ol>
                        <li> The purpose of this Privacy Notice is to protect the personal and sensitive data of our
                            applicants, future and current clients, whether they are natural and legal persons, management
                            personnel, administrative personnel, suppliers and members of the board of directors, through
                            their legitimate, controlled and informed treatment, in order to guarantee your privacy, as well as
                            your right to informational self-determination.</li>
                        <li>
                            By providing your Personal and Sensitive Data in printed, digital, visual, sound form, by means
                            of email and any other communication vehicle, you accept and authorize the company GRUPO
                            MOTOMEX, S.A. DE C.V. and subsidiaries to use, manipulate and automatically process your
                            supplied personal and sensitive data, which will form part of our database for the purpose of using
                            them, including but not limited to, to: identify you, locate you, communicate, contact you , send
                            you information, grant you commercial proposals, etc.; as well as to send and/or transfer them to
                            third parties, inside and outside the national territory, by any means permitted by law to fulfill our
                            social purposes. By accepting and authorizing the processing of your personal data in the
                            aforementioned terms, you expressly authorize us to transfer them to public and private
                            organizations, various companies and/or individuals, inside and outside of Mexico..
                        </li>
                        <li>
                            The temporality of the handling of your Personal Data will be indefinite from the date you
                            provide it to us, and you may oppose the handling of the same at any time you consider
                            appropriate, in accordance with the Law; In the event that your request for opposition is
                            appropriate, the Company GRUPO MOTOMEX, S.A. DE C.V. and subsidiaries, will stop
                            handling your Personal Data without any responsibility on our part.
                        </li>
                        <li>
                            The area responsible for the processing of your personal data is obliged to comply with the
                            principles of legality, consent, information, quality, purpose, loyalty, proportionality and
                            responsibility protected by Law; For this reason, based on articles 13 and 14 of the Law, we
                            undertake to keep your personal data strictly confidential, as well as to maintain
                            administrative, technical and physical security measures that allow us to protect them against
                            any damage, loss, alteration, unauthorized access or processing.
                        </li>
                        <li> In terms of the provisions of article 22 of the Law, you have the right at any time to
                            exercise your rights of access, rectification, cancellation and opposition to the processing of
                            your personal data, by request via email addressed to privacidad@ motomex.com or in
                            writing at the address described above, a request that must contain the requirements
                            established by Law.</li>
                        <li>The Company GRUPO MOTOMEX, S.A. DE C.V and subsidiaries, will occasionally modify
                            and correct this Privacy Notice, sending the new terms and conditions to the Owner of the
                            information in the same way as this one..
                        </li>
                    </ol>
                </section>
                <section className='place_date'>
                    <hr className='place_date_horzontal_line'></hr>
                    <span className='place_date_text'>Place and date</span>
                </section>
                <section className='place_date'>
                    <hr className='place_date_horzontal_line'></hr>
                    <span className='name_signature_text'>NAME AND SIGNATURE OF ACKNOWLEDGMENT AND ABSOLUTE CONFORMITY</span>
                </section>
                <section>
                    <img alt="kdmfooter" src={Image_Url.KDMFOOTER} className='kdm_header_footer'/>
                </section>
            </main>
        </div>
    )
}

export default KdmPrivacypolicy;